export const SIZES = {
  mobile: 480,
  tablet: 768,
  laptop: 1024,
  desktop: 1200,
} as const;

export const QUERIES = {
  // Desktop-first queries
  maxMobile: `@media (max-width: ${SIZES.mobile}px)`,
  maxTablet: `@media (max-width: ${SIZES.tablet}px)`,
  maxLaptop: `@media (max-width: ${SIZES.laptop}px)`,
  maxDesktop: `@media (max-width: ${SIZES.desktop}px)`,
} as const;
